export class NamedError extends Error {}
